var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaEmploymentBased(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#6400FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.321,
    y: 68.028,
    width: 71.357,
    height: 29.821,
    rx: 0.925,
    fill: "#A063FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.321 54.043c0-.511.415-.925.925-.925h69.508c.51 0 .925.414.925.925v29.41S90.964 87.199 70 87.199c-20.964 0-35.679-3.746-35.679-3.746v-29.41z",
    fill: "#9856FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.256 49.782c0-.51.414-.925.925-.925h71.638c.51 0 .925.415.925.925v28.204c0 .709-.478 1.322-1.171 1.473-3.941.855-17.503 3.48-35.573 3.48s-31.632-2.625-35.573-3.48a1.493 1.493 0 01-1.17-1.473V49.782z",
    fill: "#DAC2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.961 78.478c3.332 1.487 15.062 4.46 35.332 4.46 20.27 0 32.938-2.974 36.739-4.46",
    stroke: "#B687FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.272 76.886h7.455v10.312h-7.455z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6BBFF",
    d: "M66.272 82.26h7.455v4.938h-7.455z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.175 48.875v-3.64a3.083 3.083 0 013.084-3.084h31.483a3.083 3.083 0 013.083 3.083v3.641",
    stroke: "#9856FF",
    strokeWidth: 4
  })));
}
export default SvgVisaEmploymentBased;